<template>
    <Head title="Rollstühle " />

    <HeroSection />
    <CostSection />
    <ContentSectionList />
    <TestimonialSection :testimonials="testimonials" />
    <FAQSection :faqs="faqs" />
    <CTASection :style="'green'" />
</template>

<script setup>
import HeroSection from '@/Components/Wheelchair/HeroSection.vue'
import FAQSection from '@/Components/Sections/FAQSection.vue'
import ContentSectionList from '@/Components/Wheelchair/ContentSectionList.vue'
import CostSection from '@/Components/Wheelchair/CostSection.vue'
import TestimonialSection from '@/Components/Sections/TestimonialSection.vue'
import PageLayout from '@/Layouts/PageLayout.vue'
import CTASection from '@/Components/Sections/CTASection.vue'

import { Head } from '@inertiajs/vue3'

// persistent layout
defineOptions({
    layout: PageLayout,
})

const faqs = [
    {
        id: 1,
        question: 'Welchen elektrischen Rollstuhl zahlt die Krankenkasse?',
        answer: 'Elektrische Rollstühle gehören zu den medizinischen Hilfsmitteln und werden von den Krankenkassen als Krankenfahrstuhl gelistet. Dementsprechend werden sie bei nachweislicher medizinischer Notwendigkeit auch bezuschusst. Medizinische Voraussetzungen bedingen, ob Sie auf das Hilfsmittel Rollstuhl angewiesen sind und dieser für die individuelle Mobilität unabdingbar ist.',
    },
    {
        id: 2,
        question: 'Kann ich mit einem elektrischen Rollstuhl reisen?',
        answer: 'So einfach können Sie Urlaub mit Rollstuhl machen! Wenn Sie auf einen Rollstuhl angewiesen sind, können Sie Ihre Reise entspannt, auch mit eingeschränkter Mobilität, antreten. Fliegen mit Elektrorollstuhl ist durch unkomplizierten Ablauf am Flughafen ganz einfach. Die Akkus können einfach herausgenommen und im Handgepäck transportiert werden, während ein faltbarer Elektrorollstuhl als normales Gepäck aufgegeben wird.',
    },
    {
        id: 3,
        question: 'Wie kann mir Leben-ohne-Grenzen helfen?',
        answer: 'Unser kostenloser Produkt- und Anbietervergleich unterstützt Sie darin, das Produkt zu finden, welches genau zu Ihren individuellen Ansprüchen und Voraussetzungen passt. Wir übernehmen das Filtern der Angebote und Hersteller, damit Sie mobil und flexibel sein können. Gerne beraten wir Sie auch zu verfügbaren Zuschüssen und Finanzierungsmöglichkeiten. Jetzt den optimalen Rollstuhl finden.',
    },
]

const testimonials = [
    {
        id: 6,
        type: 'wheelchair',
        title: '',
        href: '#',
        body: 'Leben-ohne-Grenzen hat mir geholfen, den perfekten elektrischen Rollstuhl zu finden! Die Beratung war äußerst professionell und das Team war sehr einfühlsam.',
        // imageUrl: "/img/home/lifta-treppenlift.png",
        author: {
            name: 'Marlon Beck',
            handle: 'marlonbeck',
            // imageUrl: "/img/home/lifta-treppenlift.png",
        },
    },
    {
        id: 7,
        type: 'wheelchair',
        title: '',
        href: '#',
        body: 'Ich war überwältigt von den vielen Optionen für elektrische Rollstühle, aber dank dem E-Rolli-Check von Leben-ohne-Grenzen wurde die Auswahl viel einfacher.  Ich kann ihren Service nur wärmstens empfehlen!',
        // imageUrl: "/img/home/lifta-treppenlift.png",
        author: {
            name: 'Elara Winters',
            handle: 'elarawinters',
            // imageUrl: "/img/home/lifta-treppenlift.png",
        },
    },
    {
        id: 8,
        type: 'wheelchair',
        title: '',
        href: '#',
        body: 'Leben-ohne-Grenzen hat mir den Prozess bis zum Rollstuhl so viel einfacher gemacht. Ich musste nicht mal etwas dazu zahlen, weil alles komplett von der Kasse übernommen wurde.',
        // imageUrl: "/img/home/lifta-treppenlift.png",
        author: {
            name: 'Azura Khan',
            handle: 'azurakhan',
            // imageUrl: "/img/home/lifta-treppenlift.png",
        },
    },
    {
        id: 9,
        type: 'wheelchair',
        title: '',
        href: '#',
        body: 'Die Unterstützung, die ich von Leben-ohne-Grenzen erhalten habe, war unglaublich. Sie haben mir geholfen, ganz einfach meinen  E-Rollstuhl zu beantragen, und haben mich durch den gesamten Prozess begleitet.',
        // imageUrl: "/img/home/lifta-treppenlift.png",
        author: {
            name: 'Lea Richter',
            handle: 'learichter',
            // imageUrl: "/img/home/lifta-treppenlift.png",
        },
    },
    {
        id: 10,
        type: 'wheelchair',
        title: '',
        href: '#',
        body: 'Genau das, was ich gebraucht habe, um die richtige Entscheidung zu treffen. Sie haben mir geholfen, einen Rollstuhl zu finden, der nicht nur meinen Bedürfnissen entspricht, sondern auch finanzierbar ist!',
        // imageUrl: "/img/home/lifta-treppenlift.png",
        author: {
            name: 'Sandra Alavi',
            handle: 'sandraalavi',
            // imageUrl: "/img/home/lifta-treppenlift.png",
        },
    },
]
</script>
